import { Line, mixins } from 'vue-chartjs';
import chartMixin from './chartMixin';
export default {
  name: 'NiotaClassicChartsLine',
  extends: Line,
  mixins: [mixins.reactiveProp, chartMixin],
  props: {
    chartData: {
      type: Object,
      required: false,
      default: function _default() {
        return {};
      }
    },
    chartDataT: {
      type: Object,
      default: function _default() {
        return {};
      },
      required: false
    },
    multiChartDataT: {
      type: Object,
      default: function _default() {
        return {};
      },
      required: false
    },
    options: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  watch: {
    multiChartDataT: {
      handler: function handler() {
        this.updateLineChart();
      },
      deep: true
    },
    chartDataT: {
      handler: function handler() {
        this.updateLineChart();
      },
      deep: true
    }
  },
  mounted: function mounted() {
    this.updateLineChart();
  },
  methods: {
    updateLineChart: function updateLineChart() {
      var mappedChartData = this.mapChartData();
      var chartOptions = this.chartOptions(this.options);
      this.renderChart({
        labels: mappedChartData.labels,
        datasets: mappedChartData.datasets
      }, chartOptions);
    },
    mapChartData: function mapChartData() {
      var _this = this;

      if (this.multiChartDataT.individual) {
        return {
          datasets: this.multiChartDataT.individual.map(function (dataset, index) {
            var color = (_this.multiChartDataT.common || {}).color ? _this.shadeColor(10 - index * 30, _this.multiChartDataT.common.color || '#17bc00') : dataset.color;
            return {
              label: dataset.label,
              pointBackgroundColor: color,
              borderColor: color,
              backgroundColor: 'transparent',
              pointRadius: dataset.pointRadius !== undefined ? dataset.pointRadius : 1,
              pointHitRadius: dataset.pointHitRadius !== undefined ? dataset.pointHitRadius : undefined,
              borderWidth: 2,
              lineTension: 0.3,
              data: dataset.data
            };
          }),
          labels: (this.multiChartDataT.common || {}).labels
        };
      } else {
        var color = this.shadeColor(10, this.chartDataT.color || '#17bc00');
        return {
          labels: this.chartDataT.dataLabels,
          datasets: [{
            label: this.chartDataT.label,
            pointBackgroundColor: color,
            borderColor: color,
            backgroundColor: 'transparent',
            pointRadius: 1,
            borderWidth: 2,
            lineTension: 0.3,
            data: this.chartDataT.data
          }]
        };
      }
    }
  }
};